import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Divider,
  makeStyles,
  Typography,
} from '@material-ui/core';
import PrivateRoute from '../../auth/Routes/PrivateRoute';
import { Switch } from 'react-router-dom';
import {
  ADD_USER_TEENYEBEANS_PORTAL_ROUTE_PREFIX,
  TB_PORTAL_SCHOOL_DETAILS_ROUTE,
  TB_PORTAL_SCHOOL_UPDATE_ROUTE,
  TB_PORTAL_WEBSITE_ROUTE,
  TEENYEBEANS_PORTAL_ROUTE_PREFIX,
} from '../../routes/routes';
import { useSelector } from 'react-redux';
import AddSchool from './TeenybeansSchools/AddSchool';
import AllSchools from './TeenybeansSchools/AllSchools';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import ViewDetails from './TeenybeansSchools/SchoolDetails/ViewDetails';
import UpdateSchool from './TeenybeansSchools/SchoolDetails/UpdateSchool';
import useScopes from '../../hooks/useScopes';
import TeenybeansSideNavBar from './TeenybeansSideNavBar';
import TeenybeansWebsite from './Website/TeenybeansWebsite';

const useStyles = makeStyles((theme) => ({
  overAll: {
    maxWidth: 1452,
    backgroundColor: theme.palette.buzzContainerColor,
    borderRadius: 4,
    padding: 44,
    paddingTop: 24,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Rubik',
  },
  underLine: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  pointer: { cursor: 'pointer' },
}));

const DoNotHaveAccess = () => {
  return (
    <Box
      fontFamily={'Rubik'}
      width={'100%'}
      minHeight={400}
      display="flex"
      justifyContent={'center'}
      alignItems="center">
      <Box maxWidth={500} fontSize={16} textAlign={'center'}>
        <Box mb={1}>You do not have access to this feature</Box>
        <Box fontSize={12}>
          NOTE: You are seeing this screen because you did not complete your KYC
          or you do not have permission to view this screen or You are not a
          PLATINUM member
        </Box>
      </Box>
    </Box>
  );
};

function TeenybeansPortalScreen() {
  const classes = useStyles();
  const { pathname } = useLocation();
  const { access } = useScopes();

  const { moduleAccess } = useSelector(({ signInReducer }) => {
    return {
      moduleAccess: signInReducer.me
        ? signInReducer.me.data
          ? signInReducer.me.data.role
          : []
        : [],
    };
  });

  return (
    <Container className={classes.overAll}>
      {pathname === '/teenybeans-portal/view-details' ||
      pathname === '/teenybeans-portal/school-update' ? null : (
        <>
          <Box
            display="flex"
            flex={1}
            justifyContent="center"
            alignItems="center">
            <Box flex={1} flexGrow={1}>
              <Typography variant="h4" component="div">
                <Box fontWeight="fontWeightMedium">
                  {pathname === '/teenybeans-portal/add-school'
                    ? 'Add School'
                    : 'Teeny Beans Management'}
                </Box>
              </Typography>
              <Typography variant="subtitle1" color="textSecondary">
                {pathname === '/teenybeans-portal/add-school'
                  ? 'Add a school and information'
                  : 'Managing Teeny Beans'}
              </Typography>
            </Box>
            {pathname === '/teenybeans-portal/add-school' ? (
              <Box flex={1} textAlign={'right'}>
                <Link to="/teenybeans-portal">
                  <Button variant="outlined" color="primary">
                    Cancel
                  </Button>
                </Link>
              </Box>
            ) : null}
          </Box>
          <Divider />
        </>
      )}

      <Box display="flex" flex={10}>
        {/* Only the section pages get the side nav; the school sub-pages stay full-width. */}
        {(pathname === TEENYEBEANS_PORTAL_ROUTE_PREFIX ||
          pathname === TB_PORTAL_WEBSITE_ROUTE) && (
          <Box minWidth={300} pt={4}>
            <TeenybeansSideNavBar />
          </Box>
        )}
        <Box flex={9} pt={4}>
          <Switch>
            <PrivateRoute
              exact
              path={TEENYEBEANS_PORTAL_ROUTE_PREFIX}
              component={
                moduleAccess.includes('bccSuperAdmin') ||
                access({
                  mode: 'allOf',
                  scope: ['teenybeans:readWrite'],
                })
                  ? AllSchools
                  : DoNotHaveAccess
              }
            />
            <PrivateRoute
              exact
              path={ADD_USER_TEENYEBEANS_PORTAL_ROUTE_PREFIX}
              component={
                moduleAccess.includes('bccSuperAdmin') ||
                access({
                  mode: 'allOf',
                  scope: ['teenybeans:readWrite'],
                })
                  ? AddSchool
                  : DoNotHaveAccess
              }
            />
            <PrivateRoute
              exact
              path={TB_PORTAL_SCHOOL_DETAILS_ROUTE}
              component={ViewDetails}
            />
            <PrivateRoute
              exact
              path={TB_PORTAL_SCHOOL_UPDATE_ROUTE}
              component={UpdateSchool}
            />
            <PrivateRoute
              exact
              path={TB_PORTAL_WEBSITE_ROUTE}
              component={
                moduleAccess.includes('bccSuperAdmin') ||
                access({
                  mode: 'allOf',
                  scope: ['teenybeans:readWrite'],
                })
                  ? TeenybeansWebsite
                  : DoNotHaveAccess
              }
            />
          </Switch>
        </Box>
      </Box>
    </Container>
  );
}

export default TeenybeansPortalScreen;
